module.exports = __webpack_public_path__ + "img/2024big4.6d5fca06.png";